import React, { useContext, useState } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get, isEmpty, uniqBy } from "lodash";
import { Formik } from "formik";
import {
  ManagePlanLayout,
  CsplTable as Table,
  Link,
  LoaderWrapper,
  AddToolTip,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  OPTIONS_DATA_MAPPER,
  getNullTableItem,
  FLOW_TYPES,
  INVESTMENT_RECORDS_TO_FETCH,
  MANAGE_RKAAS_ROUTES,
  manageRkaasFormNames,
  formFields,
} from "../../../utils";
import {
  createPlanStore,
  savePlanDetailsAction,
  setManagePlanToastInfo,
} from "../../../contexts";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
  useTableChecboxSelect,
} from "../../../abstracts";
import MasterFilterComponent from "./MasterFilterComponent";
import InfiniteScroll from "react-infinite-scroller";
import {
  getMasterInvestmentBySearchCriteria,
  listInvestment,
} from "../../../services";

const columns = [
  {
    label: "",
    className: "",
    columnName: "isSelected",
  },
  {
    label: "Investment Name",
    className: "column-investment-name",
    columnName: "name",
    link: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENT_DETAILS,
    isSortable: true,
    orderBy: "",
  },
  {
    label: "Investment Type",
    className: "column-investment-type",
    columnName: "investmentTypeName",
  },
  {
    label: "Investment Status",
    className: "column-investment-status",
    columnName: "status",
    dataMapper: OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER,
  },
  {
    label: "Ticker",
    className: "column-investment-ticker",
    columnName: "ticker",
  },
  {
    label: "CUSIP",
    className: "column-investment-cusip",
    columnName: "cusip",
  },
];

const ManageInvestmentsMasterContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const formName = manageRkaasFormNames.INVESTMENT_FILTER;
  const { history } = props;
  const fields = formFields[formName];
  const { planId, flow } = useRouterParams();
  const apiData = get(state, "api.data", {});
  const companyId = get(apiData, "companyId", 0);
  // let investmentData = investmentsData.map((_) => _.investmentId);
  const [investmentsData, setInvestmentsData] = useState([]);
  const [investmentData, setInvestmentData] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState({
    search: "",
    from: 0,
    to: INVESTMENT_RECORDS_TO_FETCH,
    excludeClosedInvestment: true,
    companyId: companyId,
  });

  useDeepEffect(() => {
    listInvestment(parseInt(planId)).then((response) => {
      setInvestmentsData(response.investmentPlanMappings);
      setInvestmentData(
        response.investmentPlanMappings.map((_) => _.investmentId)
      );
    });
  }, []);
  const {
    data,
    isAllChecked,
    onHeaderCheckboxClick,
    onRowItemClick,
    selectedData,
  } = useTableChecboxSelect({
    response: filteredValues,
    listData: [...investmentsData],
    isInvestment: true,
  });

  useDeepEffect(() => {
    setIsLoading(true);
    getMasterInvestmentBySearchCriteria(request)
      .then((response) => {
        if (response.length < INVESTMENT_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append) {
          setFilteredValues((filteredValues) => {
            return [
              ...filteredValues,
              ...response.map((item) => ({
                ...item,
                checked: item.isSelected,
              })),
            ];
          });
        } else {
          setFilteredValues(
            response.map((item) => ({
              ...item,
              checked: item.isSelected,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [request]);

  const onFormSubmit = (values) => {
    setAppend(false);
    setStopInfiniteScroll(false);
    setRequest({
      search: values.search,
      investmentType: values.investmentType,
      investmentStatus: values.investmentStatus,
      from: 0,
      to: INVESTMENT_RECORDS_TO_FETCH,
      excludeClosedInvestment: true,
      companyId: companyId,
    });
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
        pathParam: [flow, planId],
      }),
    },
    // {
    //   label: "New Investment",
    //   type: "button",
    //   link: getPathWithParam({
    //     path: MANAGE_PLAN_ROUTES.ADD_INVESTMENTS,
    //     pathParam: [FLOW_TYPES.ADD, planId],
    //   }),
    // },
  ];

  return (
    <Formik
      initialValues={{}}
      onSubmit={() => {}}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ setSubmitting, setFieldValue }) => {
        return (
          <ManagePlanLayout buttons={buttons}>
            <LoaderWrapper isLoading={isLoading}>
              <div className="plan-investment-master">
                <div>
                  <p className="selected-title-head py-2">
                    Selected investment from master to add to plan
                  </p>
                  {selectedData &&
                    selectedData.map((item) => (
                      <span className="selected-table-value">{item.name}</span>
                    ))}
                </div>

                <MasterFilterComponent
                  history={history}
                  fields={fields}
                  filteredValues={filteredValues}
                  onFormSubmit={onFormSubmit}
                  selectedData={selectedData}
                  setIsLoading={setIsLoading}
                  planId={planId}
                  flow={flow}
                  setSubmitting={setSubmitting}
                  data={data}
                  investmentData={investmentData}
                />

                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      {columns.map((item, index) => {
                        if (index === 0) {
                          return (
                            <Table.Th key={index} className={item.className}>
                              <Form.Check
                                custom
                                name="master-sources-radio-head"
                                type="checkbox"
                                label=""
                                id={`master-sources-radio-head`}
                                onChange={onHeaderCheckboxClick}
                                checked={
                                  isAllChecked ||
                                  data
                                    .map((investment) =>
                                      investmentData.includes(investment.id)
                                    )
                                    .reduce(
                                      (previousValue, currentValue) =>
                                        previousValue && currentValue,
                                      true
                                    )
                                }
                                disabled={data
                                  .map((investment) =>
                                    investmentData.includes(investment.id)
                                  )
                                  .reduce(
                                    (previousValue, currentValue) =>
                                      previousValue && currentValue,
                                    true
                                  )}
                              />
                            </Table.Th>
                          );
                        }
                        return (
                          <Table.Th key={index} className={item.className}>
                            {item.label}
                          </Table.Th>
                        );
                      })}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody
                    isLoading={false}
                    totalRecords={filteredValues.length}
                  >
                    <div style={{ overflowY: "scroll", maxHeight: "40vh" }}>
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={() => {
                          setAppend(true);
                          setRequest((request) => {
                            return {
                              ...request,
                              from: filteredValues?.length,
                              to:
                                filteredValues?.length +
                                INVESTMENT_RECORDS_TO_FETCH,
                            };
                          });
                        }}
                        hasMore={!stopInfiniteScroll}
                        initialLoad={false}
                        threshold={100}
                        useWindow={false}
                        loader={
                          <div className="loader" key={0}>
                            Loading ...
                          </div>
                        }
                      >
                        <div style={{ overflowY: "scroll", maxHeight: "100%" }}>
                          {!isEmpty(data) ? (
                            data.map((investment, index) => {
                              const onRowCheckboxClick = () => {
                                setFieldValue("dummy", true); // addition this to triggere dirty check flag
                                onRowItemClick(investment, index);
                              };
                              return (
                                <Table.Tr key={index}>
                                  {columns.map((item, cellIndex) => {
                                    const getContent = () => {
                                      if (cellIndex === 0) {
                                        return (
                                          <Form.Check
                                            custom
                                            name={item.columnName}
                                            type="checkbox"
                                            label=""
                                            id={`${item.columnName}-${index}`}
                                            checked={
                                              investment.checked ||
                                              investmentData.includes(
                                                investment.id
                                              )
                                            }
                                            onChange={onRowCheckboxClick}
                                            disabled={investmentData.includes(
                                              investment.id
                                            )}
                                          />
                                        );
                                      }
                                      if (!isEmpty(item.link)) {
                                        return investment[item.columnName]
                                          .length >= 15 ? (
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip>
                                                {investment[item.columnName]}
                                              </Tooltip>
                                            }
                                          >
                                            <Link
                                              to={getPathWithParam({
                                                path: item.link,
                                                pathParam: [
                                                  flow,
                                                  planId,
                                                  investment.id,
                                                ],
                                              })}
                                            >
                                              {investment[
                                                item.columnName
                                              ].slice(0, 15) + "..."}
                                            </Link>
                                          </OverlayTrigger>
                                        ) : (
                                          <Link
                                            to={getPathWithParam({
                                              path: item.link,
                                              pathParam: [
                                                flow,
                                                planId,
                                                investment.id,
                                              ],
                                            })}
                                          >
                                            <AddToolTip
                                              name={investment[item.columnName]}
                                            />
                                          </Link>
                                        );
                                      }
                                      if (item.dataMapper) {
                                        return (
                                          <AddToolTip
                                            name={
                                              item.dataMapper[
                                                investment[item.columnName]
                                              ]
                                            }
                                          />
                                        );
                                      }
                                      if (
                                        item.columnName === "cusip" ||
                                        item.columnName === "ticker"
                                      ) {
                                        if (investment.type === 1) {
                                          return (
                                            <AddToolTip name={"Multiple"} />
                                          );
                                        }
                                        return "-";
                                      }
                                      return (
                                        <AddToolTip
                                          name={investment[item.columnName]}
                                        />
                                      );
                                    };

                                    return (
                                      <Table.Td
                                        key={cellIndex}
                                        className={item.className}
                                      >
                                        {getNullTableItem(getContent())}
                                      </Table.Td>
                                    );
                                  })}
                                </Table.Tr>
                              );
                            })
                          ) : (
                            <div className="d-flex align-items-center justify-content-center">
                              No Records Found
                            </div>
                          )}
                        </div>
                      </InfiniteScroll>
                    </div>
                  </Table.Tbody>
                </Table>
              </div>
            </LoaderWrapper>
          </ManagePlanLayout>
        );
      }}
    </Formik>
  );
};

export default ManageInvestmentsMasterContainer;
